<template>
    <div id="app">
        <app-header />
        <main>
            <cookie-warning />
            <router-view />
            <browser-check />
        </main>
        <app-footer />
    </div>
</template>

<script>

    import Header from './components/header/Header.vue'
    import Footer from './components/footer/Footer.vue'
    import cookieWarning from './components/cookiewarning/CookieWarning.vue'
    import browserCheck from './components/browsercheck/BrowserCheck.vue'
    
    export default {
        components: {
            appHeader: Header,
            appFooter: Footer,
            cookieWarning: cookieWarning,
            browserCheck: browserCheck
        },
        created: function() {
            // In case of browser refresh, check user's session.
            this.$store.dispatch('autoLogin') 
        }
    }

</script>

<style lang="scss">

    /* Import global styles */
    @import './styles/elements.scss';
    @import './styles/classes.scss';

    #app {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
    }

</style>